const target_components = {
  PATIENTS: 'patients',
  PROTOCOLS: 'protocols',
  CALLLOGS: 'calllogs',
  FOLLWUP_DOCTOR: 'followup_doctor',
  FOLLWUP_SALE: 'followup_sale',
};

export { target_components };
